import { Box, Tab, Tabs, Typography } from "@mui/material"
import { useState } from "react"
import { a11yProps, TabPanel } from "../../components/tab";
import ConfigPainelChamadaCadastro from "../configPainelChamada/view/confpc.cad";
import MedicoList from "../medico/view/medico.list";
import SalaList from "../sala/view/sala.list";

const CentralConfiguracoes = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleChangeTab = (event: React.SyntheticEvent, value: any) => {
        setTabValue(value);
    }

    return (
        <Box sx={{ display: "flex", flex: 1, flexDirection: "column", pt: 1, width: "100%" }}>
            <Box sx={{ display: "flex", flex: 1, borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="Configuracoes">

                    <Tab label={<Typography variant="subtitle1">Profissionais</Typography>} {...a11yProps(0)} />
                    <Tab label={<Typography variant="subtitle1">Salas</Typography>} {...a11yProps(1)} />
                    <Tab label={<Typography variant="subtitle1">Painel de Chamada</Typography>} {...a11yProps(2)} />

                </Tabs>
            </Box>

            <TabPanel  value={tabValue} index={0}  >
                <MedicoList/>
            </TabPanel>
            <TabPanel  value={tabValue} index={1}  >
                <SalaList/>
            </TabPanel>
            <TabPanel  value={tabValue} index={2}  >
                <ConfigPainelChamadaCadastro/>
            </TabPanel>
        </Box>
    )
}
export default CentralConfiguracoes